import * as React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { Header } from '@atlaskit/side-navigation';
import { SkeletonItem } from '@atlassian/help-center-common-component/skeleton-item';

const SidebarHeaderSkeleton: React.FC = () => {
    return (
        <Header
            iconBefore={<SkeletonItem height="24px" width="100%" data-testid="icon-skeleton" />}
            description={<SkeletonItem height="16px" width="65%" data-testid="description-skeleton" />}
        >
            <Box xcss={skeletonHeadingStyles}>
                <SkeletonItem height="16px" width="85%" data-testid="title-skeleton" />
            </Box>
        </Header>
    );
};

const skeletonHeadingStyles = xcss({
    paddingBlockEnd: 'space.025',
});

export default SidebarHeaderSkeleton;
